import { useEffect } from 'react';
export function useTailwindTheme(theme) {
  useEffect(() => {
    const root = document.documentElement;

    const defaultTheme = {
      primary: '#F9A527',
      secondary: '#FF7F50',
      text: '#202020',
    };

    const activeTheme = theme || defaultTheme;

    root.style.setProperty('--color-primary', activeTheme.primary);
    root.style.setProperty(
      '--color-secondary',
      activeTheme.secondary,
    );
    root.style.setProperty('--color-text', activeTheme.text);
  }, [theme]);
}
